module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/LB-722670407fc49e1a6c677603b8177402.png";